import type { PopupFieldConfig } from '@onetext/api';

export const fieldConfig : PopupFieldConfig = {
    style: {
        borderRadius: '50px',
        paddingLeft:  '16px',
        paddingRight: '16px'
    }
};
